export class OnboardingUserDetails {

    constructor(public applicationCreationResponse: string, public permissionResponse: string,
        public email: string, public firstName: string,
        public lastName: string, public telephoneNumber: string,
        public userId: string, public userName: string,
        public userCreationResponse: string, public userStatus: string, public permissionStatus: string, public applicationGuid: string,
        public applicationName: string, public applicationLoginUrl: string, public baseUrl: string, public clientId: string, public clientSecret: string, public realm : string) {
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/onboardingUserForgerock/onboard-user-details.ts
 **/